import React__default from 'react';
import { ServiceIconShell } from '../ServiceIconShell/ServiceIconShell.es.js';

const serviceIconNumeric = "_service-icon-numeric_1ldi5_1";
const styles = {
	serviceIconNumeric: serviceIconNumeric
};

const PDLFontMap = (iconSize, collapsedIconCount) => {
  switch (iconSize) {
    case "small":
      return "--zds-small-print-3";
    case "medium":
    case "large":
      return collapsedIconCount <= 9 ? "--zds-paragraph-header-3" : "--zds-body-3";
    default:
      return "--zds-paragraph-header-3";
  }
};
const ServiceIconNumeric = (props) => {
  const { size, hasBorder = true, hasWhiteBackground } = props;
  const label = `Plus ${props.number} more apps.`;
  const text = props.number > 99 ? `99+` : `+${props.number}`;
  const font = PDLFontMap(size, props.number);
  return React__default.createElement(
    ServiceIconShell,
    { size, hasBorder, hasWhiteBackground },
    React__default.createElement(
      "span",
      { "aria-label": label, className: styles.serviceIconNumeric, style: {
        font: `var(${font})`
      }, role: "img", "data-zds": true },
      React__default.createElement("span", { "aria-hidden": "true", "data-zds": true }, text)
    )
  );
};

export { ServiceIconNumeric };
//# sourceMappingURL=ServiceIconNumeric.es.js.map
